import api from "../utils/axios";

export const uploadDocument = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  // Use the imported axios instance instead of hardcoding URL
  const response = await api.post("/documents/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    withCredentials: false
  });

  return response.data;
};

export const getDocuments = async () => {
  const response = await api.get("/documents/");
  return response.data;
};
